import React from "react";
import { Link, useParams } from "react-router-dom";
import { useSelector } from "react-redux";

import { Spinner } from "react-bootstrap";

import {
  ROUTE_STUDENT,
  ROUTE_TEACHER,
  ROUTE_TOKEN_DETAIL,
  ROUTE_FINANCIAL_FACTOR_DETAIL,
} from "../../../../../routes";

import { paymentStatus, userGenders } from "../../../../../libs/getConstants";

import ButtonComponent from "../../../../public/button";

import {
  FinancialTableWrapper,
  CompanyContainerDetail,
  FinancialTableBodyRow,
  FinancialTableDetail,
  FinancialTableHeaderRow,
} from "../userFinancialPersonalDetailComponent/styledUserFinancialPersonalDetailComponent";
import { StatusFinancialBadge } from "../userFinancialListPersonalComponent/styledUserFinancialListPersonalComponent";

function UserFinancialCompanyDetailComponent({
  financialData,
  postCardIsLoading,
  handleChangeCheckboxUpgrade,
  handleUpgradeCompanyPurchase,
}) {
  const { id: factorID } = useParams();
  const userRole = useSelector((state) => state.userDetail.userRole);

  const paymentStatusConstants = paymentStatus();
  const genders = userGenders();

  const userRoleRoute = userRole === "student" ? ROUTE_STUDENT : ROUTE_TEACHER;

  return (
    <>
      <CompanyContainerDetail className="w-100">
        <tbody>
          <tr>
            <td>سازمانی</td>
            <td>{financialData?.education?.name}</td>
            <td>{genders[financialData?.education?.gender]}</td>
            <td className="px-sm-3">{financialData.education.city_str}</td>
            <td className="px-sm-3">
              <StatusFinancialBadge>
                {paymentStatusConstants[financialData.status]}
              </StatusFinancialBadge>
            </td>
            <td>{financialData?.total?.toLocaleString()} تومان </td>
            <td>
              <ButtonComponent
                isLink={true}
                to={`${userRoleRoute}/${ROUTE_FINANCIAL_FACTOR_DETAIL}/${factorID}`}
                variant="outline-primary factor-btn"
                className="justify-content-center"
              >
                مشاهده فاکتور
              </ButtonComponent>
            </td>
          </tr>
        </tbody>
      </CompanyContainerDetail>

      <FinancialTableWrapper className="pt-2 pb-5">
        <FinancialTableDetail>
          <thead>
            <FinancialTableHeaderRow>
              <th>نام</th>
              <th>تعداد</th>
              <th>پایه</th>
              {/* <th>مبلغ </th> */}
              <th>کد اشتراک</th>
              <th>تمدید</th>
            </FinancialTableHeaderRow>
          </thead>
          <tbody>
            {financialData.invoicedetails_set.map((item, index) => {
              return (
                <FinancialTableBodyRow key={index}>
                  <td>{item.unit_of_time.name}</td>
                  <td>{item.count}</td>
                  <td>{item.grade.name}</td>
                  {/* <td>{item.unit_of_time.price.toLocaleString()}</td> */}
                  <td>
                    {!item.token_sim ? (
                      <>وجود ندارد</>
                    ) : (
                      <Link
                        to={`${userRoleRoute}/${ROUTE_TOKEN_DETAIL}${item.token_sim.id}`}
                      >
                        {item.token_sim.value}
                      </Link>
                    )}
                  </td>
                  <td className="text-nowrap">
                    {item.unit_of_time.upgrade ? (
                      <>
                        تمدید سفارش
                        <input
                          type="checkbox"
                          id={item.id}
                          name={item.count}
                          onChange={handleChangeCheckboxUpgrade}
                        />
                      </>
                    ) : (
                      <>غیر قابل تمدید</>
                    )}
                  </td>
                </FinancialTableBodyRow>
              );
            })}
          </tbody>
        </FinancialTableDetail>
        <div className="text-center">
          <ButtonComponent onClick={handleUpgradeCompanyPurchase}>
            {postCardIsLoading ? (
              <Spinner
                as="span"
                animation="border"
                role="status"
                aria-hidden="true"
              />
            ) : (
              "تمدید سفارش‌های انتخاب شده"
            )}
          </ButtonComponent>
        </div>
      </FinancialTableWrapper>
    </>
  );
}

export default UserFinancialCompanyDetailComponent;
